/**
 * Created by shubham on 16/4/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { ViewRequestComponent } from './view-request.component';
import { ViewPartnersRequestComponent } from './viewPartners/viewPartners.component';
import { ViewSubUsersRequestComponent } from './viewSubUsers/viewSubUsers.component';
import { ViewApplicationRequestComponent } from './viewApplicationRequest/viewApplicationRequest.component';

export const RequestRoutes: Routes = [
    {
        path: '',
        component: ViewRequestComponent,
        children: [
            { path: '', redirectTo: '/app/admin-dashboard', pathMatch: 'full' },
            { path: 'viewPartners/:id', component: ViewPartnersRequestComponent },
            { path: 'viewSubUsers/:id', component: ViewSubUsersRequestComponent },
            { path: 'viewApplicationRequest/:id', component: ViewApplicationRequestComponent },
        ]
    }
];

export const RequestRoutingModule = RouterModule.forChild(RequestRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/view-request-routing.module.ts